import { Authenticator } from "@aws-amplify/ui-react";
import ModalProvider from "mui-modal-provider";
import { ApplicationStoreProvider } from "./context/ApplicationStoreContext";
import { AppRouter } from "./route";

function App() {
  return (
    <Authenticator.Provider>
      <ApplicationStoreProvider>
        <ModalProvider>
          <AppRouter />
        </ModalProvider>
      </ApplicationStoreProvider>
    </Authenticator.Provider>
  );
}

export default App;
